import type { NotificationFilter } from '@ui';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface NotificationsUiState {
  panelOpen: boolean;
  filter: NotificationFilter;
}

const initialState: NotificationsUiState = { panelOpen: false, filter: 'all' };

/** UI state only – the notification list itself is server state (see queries.ts). */
export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    openNotifications: (state) => {
      state.panelOpen = true;
    },
    closeNotifications: (state) => {
      state.panelOpen = false;
    },
    setNotificationFilter: (state, action: PayloadAction<NotificationFilter>) => {
      state.filter = action.payload;
    },
  },
  selectors: {
    selectNotificationsOpen: (state) => state.panelOpen,
    selectNotificationFilter: (state) => state.filter,
  },
});

export const { openNotifications, closeNotifications, setNotificationFilter } =
  notificationsSlice.actions;
export const { selectNotificationsOpen, selectNotificationFilter } = notificationsSlice.selectors;
